<template>
  <div>
    <div class="ovf-hd m-t-20">
      <div class="fl">操作区配置</div>
      <div class="fl m-l-20">
        <el-button size="small" type="primary" @click="addOperation()">添加</el-button>
      </div>
    </div>
    <div class="m-t-10">
      <el-table
        :data="componentData"
        border
        style="width: 100%"
        :row-class-name="tableRowClassName">
        <el-table-column
          label="功能点"
          width="180">
          <template scope="scope">
            <span>{{ scope.row.type | operation }}{{ scope.row.iden }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="关联">
          <template scope="scope">
            <div>{{applicationById}}</div>
            <span v-if="allOperationById[scope.row.id]">{{ allOperationById[scope.row.id] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="位置">
          <template scope="scope">
            <span>{{ scope.row.pos | position }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="100">
          <template scope="scope">
            <el-button type="text" size="small" @click="setConfig(scope.$index, scope.row)">配置</el-button>
            <el-button type="text" size="small" @click="deleteOperation(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<style>
.el-table .row-focus {
  background: rgba(255, 102, 102, .2)
}
</style>
<script>
export default {
  name: 'operationTable',
  props: {
    showType: {
      type: String,
      default() {
        return ''
      }
    },
    componentData: {
      type: Array,
      default() {
        return []
      }
    },
    private: {
      type: Boolean,
      default() {
        return true
      }
    },
    listIndex: {
      type: Number,
      default() {
        return 0
      }
    },
    focusIndex: {
      type: Number,
      default() {
        return 0
      }
    },
    operationPrivate: {
      type: Boolean,
      default() {
        return true
      }
    },
    application: {
      type: Array,
      default() {
        return []
      }
    },
    allOperationById: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      focusRow: -1,
      operationObj: {
        id: '',
        iden: '',
        name: '',
        type: null,
        pos: null
      }
    }
  },
  created() {
  },
  methods: {
    addOperation() {
      let newOperation = _.cloneDeep(this.operationObj)
      if (!this.private) {
        newOperation.pos = 20
      }
      this.$emit('addOperation', this.private, this.listIndex, newOperation)
    },
    deleteOperation(index) {
      this.$emit('deleteOperation', this.private, this.listIndex, index)
    },
    setConfig(index, item) {
      this.focusRow = index
      this.$emit('setOperationConfig', this.private, this.listIndex, index)
    },
    tableRowClassName(row, index) {
      let className = ''
      if (!this.private) {
        if (this.showType == 'operation' && !this.operationPrivate && this.focusRow == index) {
          className = 'row-focus'
        }
      } else {
        if (this.showType == 'operation' && this.operationPrivate && this.focusIndex == this.listIndex && this.focusRow == index) {
          className = 'row-focus'
        }
      }
      return className
    }
  }
}
</script>


// WEBPACK FOOTER //
// operationTable.vue?4cf4c367